import { useBetterAuthConvexAuth } from './useAppAuth';

export const useSuperAdmin = () => {
  const { convexUser, isLoadingProfile, isSuperAdmin } = useBetterAuthConvexAuth();

  return {
    isSuperAdmin,
    loading: isLoadingProfile,
    user: convexUser,
  };
};
